import { XCircle, Send, CheckCircle } from "lucide-react";

const DocRequestModal = ({
  t,
  styles,
  theme,
  language,
  isRTL,
  documentTypes,
  requestType,
  setRequestType,
  requestDetails,
  setRequestDetails,
  requestRecipient,
  setRequestRecipient,
  requestReason,
  setRequestReason,
  setShowRequestModal,
  handleRequestDocument,
}) => {
  const focusStyle = (e) => {
    e.currentTarget.style.borderColor = "#3b82f6";
    e.currentTarget.style.boxShadow =
      theme === "dark"
        ? "0 0 0 4px rgba(59, 130, 246, 0.2), 0 8px 24px rgba(0, 0, 0, 0.3)"
        : "0 0 0 4px rgba(59, 130, 246, 0.15), 0 8px 24px rgba(0, 0, 0, 0.06)";
  };

  const blurStyle = (e) => {
    e.currentTarget.style.borderColor =
      theme === "dark" ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.1)";
    e.currentTarget.style.boxShadow =
      theme === "dark" ? "0 6px 18px rgba(0, 0, 0, 0.3)" : "0 6px 18px rgba(0, 0, 0, 0.06)";
  };

  const handleClose = () => {
    setShowRequestModal(false);
    setRequestReason("");
    setRequestType("hr_letter");
    setRequestRecipient("");
    setRequestDetails("");
  };

  return (
    <div style={styles.modalOverlay} onClick={handleClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>{t.requestHRDocument}</h3>
          <button
            style={styles.closeButton}
            onClick={handleClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.06)";
            }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "none"; }}
          >
            <XCircle size={28} />
          </button>
        </div>

        {/* Document Type Selection */}
        <div style={{ marginBottom: "32px" }}>
          <label style={{ ...styles.formLabel, marginBottom: "20px" }}>
            {t.selectDocumentType}
          </label>
          {documentTypes.map((type) => {
            const Icon = type.icon;
            const isSelected = requestType === type.id;

            return (
              <div
                key={type.id}
                onClick={() => setRequestType(type.id)}
                style={styles.documentTypeCard(isSelected)}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = "#3b82f6";
                    e.currentTarget.style.transform = "translateY(-3px)";
                  //   e.currentTarget.style.boxShadow =
                  //     theme === "dark"
                  //       ? "0 10px 30px rgba(0, 0, 0, 0.4)"
                  //       : "0 10px 30px rgba(0, 0, 0, 0.1)";
                  // }
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor =
                      theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      theme === "dark"
                        ? "0 6px 18px rgba(0, 0, 0, 0.3)"
                        : "0 6px 18px rgba(0, 0, 0, 0.06)";
                  }
                }}
              >
                <div style={styles.documentTypeIcon(isSelected)}>
                  <Icon
                    size={28}
                    color={
                      isSelected
                        ? "#fff"
                        : theme === "dark"
                          ? "rgba(255, 255, 255, 0.6)"
                          : "rgba(30, 41, 59, 0.6)"
                    }
                  />
                </div>
                <div style={styles.documentTypeContent}>
                  <div style={styles.documentTypeName}>{type.name}</div>
                  <div style={styles.documentTypeDescription}>{type.description}</div>
                </div>
                {isSelected && <CheckCircle size={28} color="#3b82f6" />}
              </div>
            );
          })}
        </div>

        {/* Details (shown only for "other" type) */}
        {requestType === "other" && (
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>
              {t.documentDetails} <span style={{ color: "#ef4444" }}>{t.required}</span>
            </label>
            <textarea
              value={requestDetails}
              onChange={(e) => setRequestDetails(e.target.value)}
              placeholder={t.documentDetailsPlaceholder}
              style={styles.formTextarea}
              onFocus={focusStyle}
              onBlur={blurStyle}
            />
          </div>
        )}

        {/* Recipient */}
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>
            {t.recipient} <span style={{ color: "#ef4444" }}>{t.required}</span>
          </label>
          <input
            type="text"
            value={requestRecipient}
            onChange={(e) => setRequestRecipient(e.target.value)}
            placeholder={t.recipientPlaceholder}
            style={styles.formInput}
            onFocus={focusStyle}
            onBlur={blurStyle}
          />
        </div>

        {/* Reason */}
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>
            {t.reason}{" "}
            <span style={{ color: "rgba(107, 114, 128, 0.8)" }}>{t.optional}</span>
          </label>
          <textarea
            value={requestReason}
            onChange={(e) => setRequestReason(e.target.value)}
            placeholder={t.reasonPlaceholder}
            style={styles.formTextarea}
            onFocus={focusStyle}
            onBlur={blurStyle}
          />
        </div>

        {/* Actions */}
        <div style={styles.modalActions}>
          <button style={styles.secondaryButton} onClick={handleClose}>
            {t.cancel}
          </button>
          <button style={styles.primaryButton} onClick={handleRequestDocument}>
            <Send size={20} />
            {t.submitRequest}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocRequestModal;